import React, { useState } from 'react';

import { Button } from '@bringg/react-components';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring-shared';

import useRouteMonitoringStore from '../../../stores/helpers/use-route-monitoring-store';
import VehicleAssignerTool from '../../../components/vehicle-assigner-tool';
import { DetailedCellProps } from '../../hooks/use-columns';
import { useStores } from 'bringg-web/recipes';

import style from './vehicle-cell.module.scss';

const VehicleCell = ({ row }: DetailedCellProps) => {
	const { vehiclesStore, runStore } = useStores();
	const route = runStore.get(row.data.id);

	const vehicleName = vehiclesStore.get(route?.vehicle_id)?.name;
	const { vehicleUnassigned } = useRoutesMonitoringTranslations();
	const [vehicleAssignModalState, setVehicleAssignModalState] = useState<boolean>(false);
	const {
		routeMonitoringActionsStore: { allowToEditVehicle }
	} = useRouteMonitoringStore();
	const isRouteCompleted = !!route?.ended_at;

	if (!route) {
		return null;
	}

	if (isRouteCompleted || !allowToEditVehicle) {
		return <span>{vehicleName}</span>;
	}

	const onCloseModal = () => {
		setVehicleAssignModalState(false);
	};

	return (
		<>
			<Button
				type="link"
				onClick={() => {
					setVehicleAssignModalState(true);
				}}
				className={style.vehicleButton}
			>
				{vehicleName || vehicleUnassigned}
			</Button>

			{vehicleAssignModalState && <VehicleAssignerTool routeId={route.id} onCloseModal={onCloseModal} />}
		</>
	);
};

export default VehicleCell;
